<template>

  <edicion-facturacion
    :datos="info"
    @reload-data="loadFactData($event)"
  />

</template>
<script>
import { useRouter } from '@core/utils/utils'
import {
  onMounted, ref,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import EdicionFacturacion from './components/edicion/facturaEdit.vue'
import { datoFacturaInfo } from './components/edicion/useFacturacion'

export default {
  components: {
    EdicionFacturacion,
  },
  setup() {
    const toast = useToast()

    const info = ref({})
    const { route } = useRouter() //* Use router propieties
    const { id } = route.value.params //* Get the token from params
    const errorFact = ref(null)
    //* Load course data
    const loadFactData = (newCourse = null) => {
      // loader.value = true
      datoFacturaInfo((newCourse) || id).then(response => {
        // eslint-disable-next-line prefer-destructuring
        info.value = response.data[0]
        // loader.value = false
        // asignature.value = response
      }, error => {
        // loader.value = false
        errorFact.value = error
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información Datos facturacion]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(() => {
      if (!Number.isNaN(id) && id !== 'null') loadFactData()
    })
    return {
      info,
      loadFactData,
    }
  },
}
</script>
